import { icons } from 'lucide-react';
import { IconProps } from './index';
function toComponentCase(what: string) {
  return what.split('-').map(w => w.charAt(0).toUpperCase() + w.substring(1).toLowerCase()).join('');
}
export function IconServer({
  name,
  ...props
}: IconProps) {
  const reactComponentName = toComponentCase(name);
  const LucideIcon = icons[reactComponentName as keyof typeof icons];
  if (!LucideIcon && process.env.NODE_ENV === 'development') {
    console.warn(`icon name ${name} [${reactComponentName}] not found.`);
  }
  return LucideIcon ? <LucideIcon {...props} /> : null;
}